import { Component } from 'react';
import Loader from '../../../../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import { withRouter } from '../../../../../utils/withRouter';
import { connect } from 'react-redux';
import {
    getPhotographyAndVideographyMasterList_action,
    deletePhotographyAndVideographyMaster_action,
} from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/photography_and_videography_master_action';
import { toastError, toastSuccess } from '../../../../../utils/constants';
import Modal from 'react-modal';
import HeaderWithLogo from '../../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../../common_components/admin_module_drawer';
import Footer from '../../../../../common_components/Footer';

class PhotographyAndVideographyMasterList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading:       false,
            isDeleteOpen:    false,
            deleteID:        null,
            agencyList:      [],
        };
        this.getList          = this.getList.bind(this);
        this.onDeleteClick    = this.onDeleteClick.bind(this);
        this.confirmDelete    = this.confirmDelete.bind(this);
        this.handleAdd        = this.handleAdd.bind(this);
    }

    componentDidMount() {
        this.getList();
    }

    getList() {
        this.setState({ isLoading: true });
        this.props.getPhotographyAndVideographyMasterList_action()
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    this.setState({ agencyList: data.data || [] });
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }

    onDeleteClick(id) {
        this.setState({ isDeleteOpen: true, deleteID: id });
    }

    confirmDelete() {
        this.setState({ isLoading: true });
        this.props.deletePhotographyAndVideographyMaster_action(this.state.deleteID)
            .then((data) => {
                this.setState({ isLoading: false, isDeleteOpen: false });
                if (data.error != 1) {
                    toastSuccess('Deleted successfully.');
                    setTimeout(() => this.getList(), 200);
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false, isDeleteOpen: false });
            });
    }

    handleAdd() {
        this.props.navigate('/photographyAndVideographyMasterAU', { state: { is_add: true } });
    }

    render() {
        const { isLoading, isDeleteOpen, agencyList } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />
                <HeaderWithLogo />

                <div className="app-content with-dr-container com-height">
                    <AdminDrawer />
                    <div className="main-container">

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Photography And Videography Master</h6>
                            </div>
                        </div>

                        <div className="admin-top-space p-2 px-0">
                            <div className="row m-0">

                                <div className="card-header p-2">
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Agency contact and bank details
                                    </h3>
                                </div>

                                <div className="table-responsive mt-1">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Agency Name</th>
                                                <th className="text-center">Designation</th>
                                                <th className="text-center">Mobile</th>
                                                <th className="text-center">Telephone</th>
                                                <th className="text-center">Fax</th>
                                                <th className="text-center">Email</th>
                                                <th className="text-center">Bank Name</th>
                                                <th className="text-center">Branch / Address</th>
                                                <th className="text-center">Account Number</th>
                                                <th className="text-center">Beneficiary Name</th>
                                                <th className="text-center">Beneficiary Address</th>
                                                <th className="text-center">Swift Code</th>
                                                <th className="text-center">RTGS / IFSC</th>
                                                <th className="text-center">PAN Number</th>
                                                <th className="text-center">GST Number</th>
                                                <th className="text-center" style={{ width: 60 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {agencyList.length > 0 ? (
                                                agencyList.map((data) => (
                                                    <tr key={data.PhotographyAndVideographyID}>
                                                        <td className="text-center">{data.AgencyName}</td>
                                                        <td className="text-center">{data.Designation}</td>
                                                        <td className="text-center">{data.Mobile}</td>
                                                        <td className="text-center">{data.Telephone}</td>
                                                        <td className="text-center">{data.Fax}</td>
                                                        <td className="text-center">{data.Email}</td>
                                                        <td className="text-center">{data.BankName}</td>
                                                        <td className="text-center">{data.BranchName}</td>
                                                        <td className="text-center">{data.AccountNo}</td>
                                                        <td className="text-center">{data.BeneficiaryName}</td>
                                                        <td className="text-center">{data.BeneficiaryAddress}</td>
                                                        <td className="text-center">{data.SwiftCode}</td>
                                                        <td className="text-center">{data.RTGSIFSCCode}</td>
                                                        <td className="text-center">{data.PANNo}</td>
                                                        <td className="text-center">{data.GSTNo}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary btn-sm border-0"
                                                                onClick={() => this.props.navigate('/photographyAndVideographyMasterAU', { state: { editData: data } })}
                                                            >
                                                                <i className="fa fa-pencil action_btn_table" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm border-0"
                                                                onClick={() => this.onDeleteClick(data.PhotographyAndVideographyID)}
                                                            >
                                                                <i className="fa fa-trash action_btn_table" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={16} className="text-center">No record found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="text-end mt-2 mb-3">
                                    <button type="button" className="btn btn-aqua" onClick={this.handleAdd}>
                                        Add
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={isDeleteOpen} onRequestClose={() => this.setState({ isDeleteOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div className="modal-header p-2">
                                <h5 className="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua" onClick={this.confirmDelete}>Yes</button>
                                    <button type="button" className="btn btn-gray" style={{ marginLeft: 5 }} onClick={() => this.setState({ isDeleteOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Footer />
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        getPhotographyAndVideographyMasterList_action,
        deletePhotographyAndVideographyMaster_action,
    })(PhotographyAndVideographyMasterList)
);
